/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Rails_Legends_TitleInputs */

const en_directory_rails_legends_title = /** @type {(inputs: Directory_Rails_Legends_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Launch Legends`)
};

const zh_directory_rails_legends_title = /** @type {(inputs: Directory_Rails_Legends_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`传奇发布`)
};

/**
* | output |
* | --- |
* | "Launch Legends" |
*
* @param {Directory_Rails_Legends_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_rails_legends_title = /** @type {((inputs?: Directory_Rails_Legends_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Rails_Legends_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_rails_legends_title(inputs)
	return zh_directory_rails_legends_title(inputs)
});
export { directory_rails_legends_title as "directory.rails.legends_title" }